import React from 'react';
import { MenuIdInsight } from '@jira/navigation-apps__constants/src/MenuIdInsight.tsx';
import { AssetsAppBase } from '@jira/spa-apps__servicedesk-assets-app-base/src/AssetsAppBase.tsx';
import { workspaceResource } from '@jira/servicedesk__insight-common-services-workspace-context/src/workspaceResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { getServicedeskPageContextResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { assetsDashboardsSemanticModelResource } from '@jira/router-resources__viz-platform/src/assetsDashboardsSemanticModelResource.tsx';

import { isNewReportsNavExperienceEnabled } from '@jira/servicedesk__insight-reports-v2/src/isNewReportsNavExperienceEnabled.tsx';
import { DashboardList } from '@jira/servicedesk__insight-reports-v2/src/DashboardList.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { APP_NAMES } from '@jira/servicedesk__common/src/toPackageName.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { servicedeskCmdbAssetsDashboardsRoute } from '@jira/router-routes__servicedesk-cmdb-routes/src/servicedeskCmdbAssetsDashboardsRoute.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { Redirect, type Route } from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';

const DashboardsListPage = () => (
	<AssetsAppBase appName={APP_NAMES.INSIGHT_ASSETS_REPORTS}>
		{({ workspaceId }) => <DashboardList workspaceId={workspaceId} />}
	</AssetsAppBase>
);

export const servicedeskCmdbAssetsDashboardsRouteEntry: Route = createEntry(
	servicedeskCmdbAssetsDashboardsRoute,
	() => ({
		group: 'servicedesk',
		layout: globalLayout,
		navigation: { menuId: MenuIdInsight },
		// eslint-disable-next-line no-restricted-syntax
		component: isNewReportsNavExperienceEnabled()
			? DashboardsListPage
			: () => <Redirect to="/jira/servicedesk/assets/reports" />,
		resources: [
			...getNavigationResources(),
			...getServicedeskPageContextResources(),
			workspaceResource,
			resourceWithCondition(
				() => fg('platform_avp_enable_jsm_assets_metrics'),
				assetsDashboardsSemanticModelResource,
			),
		],
		forPaint: [LazyAtlassianNavigation],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
